import React, { useState, useEffect } from 'react';
import axios from 'axios'
import { FiBookmark, FiPlus, FiEdit3, FiInfo, FiLogOut } from 'react-icons/fi';
import MyListScreen from '../screens/MyList';
import AddNewProductScreen from '../screens/AddNewProduct';
import EnterByHandScreen from '../screens/EnterByHand';
import AboutScreen from '../screens/About';
import { SERVER_URL } from '../config';
import '../styles.css'; // Ensure this contains styles that apply globalStyles

export default function Wishlist({token}) {
  const [wishlist, setWishlist] = useState([]);
  const [, setSortOption] = useState('date'); // default sort by date
  const [sortOrder, setSortOrder] = useState({ date: 'asc', price: 'asc' }); // track sorting order for each option
  const [activeScreen, setActiveScreen] = useState('My Wishlist'); // Default screen

  
  useEffect(() => {
    // Load wishlist from localStorage when app starts (for web)
    const loadWishlist = async () => {
      try {
        const fromDB = await axios.get(`${SERVER_URL}/wishlist/${token}`);
        const storedWishlist = fromDB.data.wishlist;
        if (storedWishlist) {
          setWishlist(storedWishlist);
        }
      } catch (error) {
        console.error('Failed to load wishlist', error);
      }
    };
    loadWishlist();
  }, [token]);

  const addProductToWishlist = (product) => {
    // The product is already persisted server-side by the add routes;
    // just reflect it in local state.
    setWishlist((current) => [...current, product]);
  };

  const removeProductFromWishlist = (productId) => {
    const removeProduct = async () => {
      try {
        const response = await axios.post(`${SERVER_URL}/delete-product/${productId}`,{token});
        if (response.data.ok) {
          console.log('Product removed from wishlist');
          setWishlist(response.data.wishlist);
        } else {
          console.error('Failed to remove product from wishlist');
        }
      }
      catch (error) {
        console.error('Failed to remove product from wishlist', error);
      }
    };
    removeProduct();
  };

  const sortWishlist = (option) => {
    let sortedWishlist;
    let newSortOrder = sortOrder[option] === 'asc' ? 'desc' : 'asc';

    if (option === 'price') {
      sortedWishlist = [...wishlist].sort((a, b) =>
        newSortOrder === 'asc' ? a.price - b.price : b.price - a.price
      );
    } else {
      sortedWishlist = [...wishlist].sort((a, b) =>
        newSortOrder === 'asc' ? a.id - b.id : b.id - a.id
      );
    }

    setWishlist(sortedWishlist);
    setSortOption(option);
    setSortOrder({ ...sortOrder, [option]: newSortOrder }); // Update the sort order for the option
  };

  // Render the active screen based on the state
  let renderedScreen;
  switch (activeScreen) {
    case 'My Wishlist':
      renderedScreen = (
        <MyListScreen
          wishlist={wishlist}
          removeProductFromWishlist={removeProductFromWishlist}
          sortWishlist={sortWishlist}
        />
      );
      break;
    case 'Add New':
      renderedScreen = (
        <AddNewProductScreen
          addProductToWishlist={addProductToWishlist}
        />
      );
      break;
    case 'Enter by Hand':
      renderedScreen = (
        <EnterByHandScreen
          addProductToWishlist={addProductToWishlist}
        />
      );
      break;
    // logout
    case 'Logout':
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('wishlist');
      window.location.reload();
      break;
    case 'About':
      renderedScreen = <AboutScreen token={token} />;
      break;
    default:
      renderedScreen = null;
  }

  return (
    <div className="wishlist-container">
      <div className="tab-bar">
        <button
          className={`tab-button ${activeScreen === 'My Wishlist' ? 'active' : ''}`}
          onClick={() => setActiveScreen('My Wishlist')}
        >
          <FiBookmark size={19} strokeWidth={1.5} />
          <span className="tab-label">List</span>
        </button>
        <button
          className={`tab-button ${activeScreen === 'Add New' ? 'active' : ''}`}
          onClick={() => setActiveScreen('Add New')}
        >
          <FiPlus size={19} strokeWidth={1.5} />
          <span className="tab-label">Add</span>
        </button>
        <button
          className={`tab-button ${activeScreen === 'Enter by Hand' ? 'active' : ''}`}
          onClick={() => setActiveScreen('Enter by Hand')}
        >
          <FiEdit3 size={19} strokeWidth={1.5} />
          <span className="tab-label">By Hand</span>
        </button>
        <button
          className={`tab-button ${activeScreen === 'About' ? 'active' : ''}`}
          onClick={() => setActiveScreen('About')}
        >
          <FiInfo size={19} strokeWidth={1.5} />
          <span className="tab-label">About</span>
        </button>
        <button
          className={`tab-button ${activeScreen === 'Logout' ? 'active' : ''}`}
          onClick={() => setActiveScreen('Logout')}
        >
          <FiLogOut size={19} strokeWidth={1.5} />
          <span className="tab-label">Sign Out</span>
        </button>
      </div>
      <div className="content">
        {renderedScreen}
      </div>
    </div>
  );
}
